import { render } from "./Video.vue?vue&type=template&id=1e795980"
import script from "./Video.vue?vue&type=script&lang=js"
export * from "./Video.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__